<template>
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-spacer></v-spacer>
    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :loading="loading"
      class="elevation-1"
    >
    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchPermissions"
    />
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import { rolesService } from '../../../utils/services/roles.service';
  import Search from '../../shared/Inputs/Search';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'RolePermissions',
    components: { Search, Paginator },
    props: {
      role: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
          loading: false,
          items: [],
          totalItems: 0,
          pagination: {
            page: 1,
            itemsPerPage: 10,
            sortDesc: [false],
            sortBy: ['title'],
          },
          headers: [
            {
              text: this.$t('fields.id'),
              align: 'left',
              value: 'id',
            },
            { text: this.$t('fields.name'), value: 'name' },
          ],
          filters: {
            search: null,
          },
      };
    },
    computed: {
      requestFilters() {
        const filters = {
          search: this.filters.search,
        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),

      async fetchPermissions(forcePage) {
        this.loading = true;

        const { page, itemsPerPage } = this.pagination;
        return rolesService.getPermissions(this.role.id, {
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
        .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
    async created() {
      await this.fetchPermissions();
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchPermissions(1);
        },
      },


    },
  };
</script>
